import { GetJournalEntries } from 'domain/usecases';

import { BaseHttpService } from 'main/factories/http';

export class RemoteGetJournalEntries extends BaseHttpService<GetJournalEntries.Model> implements GetJournalEntries {
  async get(params: GetJournalEntries.Params): Promise<GetJournalEntries.Model> {
    return await this.request('get', {}, params);
  }
}
